import { render } from "./Evaluate.vue?vue&type=template&id=22a6cce4"
import script from "./Evaluate.vue?vue&type=script&lang=js"
export * from "./Evaluate.vue?vue&type=script&lang=js"

import "./Evaluate.vue?vue&type=style&index=0&id=22a6cce4&lang=scss"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__